import getProductsByCollection from '@commerce/api/operations/get-products-by-collection'
import { Breadcrumbs, Error, Layout, Loader, SeoHead } from '@components/common'
import { Container } from '@components/ui'
import getGlobalStaticProps from '@lib/globalStaticProps'
import { SliceZone } from '@prismicio/react'
import { components } from '@slices/index'
import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { createClient, findCollectionHandles, getDocByUid } from 'prismicio'

export async function getStaticProps({
  params,
  locale,
  previewData,
}: GetStaticPropsContext<{ slug: string }>) {
  const client = createClient({ previewData })
  const path = params?.slug
  const globalProps = await getGlobalStaticProps(client, locale)
  const translations = await serverSideTranslations(locale ?? 'en-au', [
    'common',
  ])
  let page = null
  let doc = null
  try {
    page = await getDocByUid('designer_colours', path!, client, locale, [
      'article.name',
      'article.title',
      'article.blogCategory',
      'article.thumbnail',
    ])
    doc = await getDocByUid('designer_colours', path!, client, locale)
  } catch (err) {
    console.log(err)
  }

  let collectionProducts: any = []
  const collectionHandles = findCollectionHandles(doc?.data?.slices)
  if (collectionHandles.length > 0) {
    for (let i = 0; i < collectionHandles.length; i++) {
      collectionProducts[i] = await getProductsByCollection(
        collectionHandles[i],
        locale,
        'no-cache'
      )
    }
  }

  if (!page || !doc) {
    return { notFound: true }
  }

  return {
    props: {
      ...globalProps,
      ...translations,
      page,
      collectionProducts,
    },
    // revalidate: 200,
  }
}

export async function getStaticPaths({ locales }: GetStaticPathsContext) {
  return {
    paths: [],
    fallback: true,
  }
}
export default function Slug({
  page,
  collectionProducts,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  const { data }: any = page || {}
  let firstCrum = {
    label: 'Designer Limewash Paint Colours',
    link: '/designer-limewash-paint-colours',
  }

  if (router.isFallback) return <Loader title="product-loader" />
  if (!data || !collectionProducts) {
    return <Error code={404} />
  }
  const crumbs = [
    firstCrum,
    {
      label: data?.name,
      link: router.asPath,
    },
  ]

  const title = data?.title
  const description = data?.description
  const name = data?.name
  const { seoImage, seoDescription, seoTitle } = data || {}
  return (
    <>
      <SeoHead
        title={seoTitle || name}
        description={seoDescription || title}
        image={seoImage}
      />
      <div className="bg-ui-light-grey">
        <Container className="pt-4 pb-6 md:pt-6 md:pb-[72px]">
          <Breadcrumbs crumbs={crumbs} />
        </Container>
        <div className="wrapper">
          {title && (
            <h1 className="lg:heading-1 heading-mobile-1 w-full pb-3 lg:w-[864px] lg:pb-4">
              {title}
            </h1>
          )}
          {description && (
            <div className="lg:heading-4 heading-mobile-4 w-full pb-6 lg:w-[864px] lg:pb-10">
              {description}
            </div>
          )}
        </div>
      </div>
      <SliceZone
        slices={data?.slices}
        components={components}
        context={{ collectionProducts }}
      />
    </>
  )
}

Slug.Layout = Layout
